const clientInfoTabs = {
  CHECKIN_ACTIVITY: 'CHECKIN_ACTIVITY',
  BILLING_DETAILS: 'BILLING_DETAILS',
  FOOD_LOG: 'FOOD_LOG',
  CLIENT_INFO: 'CLIENT_INFO',
  NOTES: 'NOTES',
  WORKOUT_CALENDAR: 'WORKOUT_CALENDAR',
  TRACK_ASSIGNMENTS: 'TRACK_ASSIGNMENTS',
  WORKOUT_HISTORY: 'WORKOUT_HISTORY',
  NUTRITIONAL_HISTORY: 'NUTRITIONAL_HISTORY',
  RECIPE_PREFERENCES: 'RECIPE_PREFERENCES',
  CLIENT_SETTINGS: 'CLIENT_SETTINGS',
  CLIENT_HISTORY: 'CLIENT_HISTORY',
  CLIENT_DOCUMENTS: 'CLIENT_DOCUMENTS',
};

export default clientInfoTabs;
